import React from "react";
import { Checkbox } from "@heroui/checkbox";

interface SharingStepProps {
  selectedOption: "library" | "private";
  setSelectedOption: (option: "library" | "private") => void;
  locationName?: string;
}

const SharingStep: React.FC<SharingStepProps> = ({
  selectedOption,
  setSelectedOption,
  locationName,
}) => (
  <div
    className="flex flex-row items-center p-3 border border-neutral-200 hover:bg-neutral-50 transition-colors duration-200 rounded-xl cursor-pointer"
    onClick={() => {
      setSelectedOption(selectedOption === "library" ? "private" : "library");
    }}
  >
    <Checkbox
      isSelected={selectedOption === "library"}
      onChange={(e) => {
        e.preventDefault();
        setSelectedOption(e.target.checked ? "library" : "private");
      }}
      radius="full"
      className="mr-6 h-4 w-4 border-neutral-300 text-indigo-600 focus:ring-indigo-600"
    />
    <div className="flex flex-col space-y-0.5">
      <h2 className="text-sm font-medium text-neutral-700">
        Share your experience
      </h2>
      <span className="text-xs text-neutral-500 font-light">
        Add this activity to the {locationName || "selected"} community library
      </span>
    </div>
  </div>
);

export default SharingStep;
